import React, { useEffect, useState } from "react";
import {
  endpoint,
  regex,
} from "../../../../views/pages/manage/common/constant";
import {
  fetchAllPostPromisedData,
  fetchAllPromisedData,
  getDropdownIdsFromSelectArray,
} from "../../../../views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { failureToast } from "../../../../views/pages/manage/common/utils/methods/toasterFunctions/function";
import { getStepsByRefundType, refundTypes } from "../config";
import { useWizard } from "../../../../components/wizard/WizardContext";
import { useSearchStudentsHandler } from "../../../studentTransfer/customHooks";
import { useParams } from "react-router-dom";

export const getBulkSearchFormFields = (data) => {
  const {
    courseIdDropdown,
    courseIdDropdownLoading,
    term,
    programActions,
    filterForm,
    setFilterForm,
    branchTypes,
    buDropdown,
    buDropdownLoading,
    cashierOfficeDropdownData,
    cashierOfficeDropdownDisabled,
  } = data;

  const resetCourseId = () => setFilterForm((prev) => ({ ...prev, courseIds: "" }));
  const resetBusinessAreas = () => setFilterForm((prev) => ({ ...prev, businessArea: "" }));

  return [
    {
      label: "Branch Type*",
      type: "select",
      items: branchTypes,
      formKey: "branchType",
      onChange: () => { resetBusinessAreas(); resetCourseId() },
      loading: false,
      isMulti: false,
      placeholder: "Select",
    },
    {
      label: "Business Area*",
      type: "select",
      items: buDropdown,
      formKey: "businessArea",
      onChange: resetCourseId,
      loading: buDropdownLoading,
      isMulti: false,
      placeholder: "Select",
    },
    {
      label: "Cashier Office*",
      type: "select",
      items: cashierOfficeDropdownData,
      formKey: "cashierOffice",
      disabled: cashierOfficeDropdownDisabled,
      onChange: () => { },
      loading: false,
      isMulti: false,
      placeholder: "Select",
    },

    {
      label: "Term*",
      type: "select",
      items: term,
      formKey: "term",
      onChange: resetCourseId,
      loading: false,
      isMulti: false,
      placeholder: "Select",
    },

    {
      label: "Course Id*",
      type: "select",
      items: courseIdDropdown,
      formKey: "courseIds",
      onChange: () => { },
      loading: courseIdDropdownLoading,
      isMulti: true,
      isShowCount: true,
      placeholder: "Select",
    },

    {
      label: "Program Action",
      type: "select",
      items: programActions,
      formKey: "programAction",
      onChange: () => { },
      loading: false,
      isMulti: false,
      placeholder: "Select",
    },

    {
      label: "Reg. Date From",
      type: "date",
      items: [],
      formKey: "registrationStartDate",
      onChange: () => { !filterForm?.registrationEndDate && setFilterForm(prev => ({ ...prev, "registrationEndDate": new Date() })) },
      loading: false,
      placeholder: "From",
      minDate: "",
      maxDate: (filterForm?.registrationEndDate || new Date())
    },

    {
      label: "Reg. Date To",
      type: "date",
      items: [],
      formKey: "registrationEndDate",
      onChange: () => { },
      loading: false,
      placeholder: "To",
      minDate: filterForm?.registrationStartDate,
      maxDate: new Date(),
    },
  ];
};

export const singleSearchParams = [
  {
    label: "PSID",
    field: "psid",
    placeholder: "Enter 11 digit PSID",
    regEx: /^[0-9]{0,11}$/,
  },
  {
    label: "Application Id",
    field: "applicationId",
    placeholder: "Enter 8 digit Application Id",
    regEx: /^[0-9]{0,8}$/,
  },
];

const getAcademicCarrier = (academicCarrierList) => {
  if (!Array.isArray(academicCarrierList) || !academicCarrierList.length)
    return [];

  return [academicCarrierList[0].label];
};

const getFilterFormReqObj = (filterForm, allActiveBu) => {
  const {
    businessArea,
    term,
    courseIds,
    registrationStartDate,
    registrationEndDate,
    programAction,
    psid,
    applicationId,
    studentName,
    cashierOffice
  } = filterForm;
  const filterBUs = !!businessArea ? [businessArea] : allActiveBu;
  const filterTerms = term ? [term] : [];

  return {
    psid,
    applicationId,
    studentName,
    businessArea: getDropdownIdsFromSelectArray(filterBUs),
    term: getDropdownIdsFromSelectArray(filterTerms),
    courseId: getDropdownIdsFromSelectArray(courseIds),
    programAction: programAction ? [programAction?.label] : [],
    startDate: registrationStartDate,
    endDate: registrationEndDate,
    cashierOffice: cashierOffice?.label
  };
};

const validateForm = (form) => {
  const { psid, applicationId } = form;
  if (psid && psid?.length != 11) {
    failureToast("PSID must be 11 digit long");
    return false;
  }

  if (applicationId && applicationId?.length != 8) {
    failureToast("Application Id must be 8 digit long");
    return false;
  }

  return true;
};

export const searchStudents = (filterForm, offset, dropdowns, limit) => {
  if (!validateForm(filterForm)) return;
  const reqObj = getFilterFormReqObj(filterForm, dropdowns?.businessAres);
  return fetchAllPostPromisedData(
    `${endpoint.allocateStudents.searchStudentApplications}?offset=${offset}${limit != null ? `&limit=${limit}` : ''}`,
    reqObj
  );
};

export const useAutoSelectStudentForRefundEdit = () => { //mimicking the user behaviour till step 2
 

  const [fetchingRefundDetails, setFetchingRefundDetails] = useState(false);

  const { dropdowns, next, setStepsConfig, updateValues , params } = useWizard();
  const { searchHandler } = useSearchStudentsHandler();

  const { mode, refundNumber } = params;

  async function init() {
    try {
      setFetchingRefundDetails(true);

      //0. fetching previously raised refund details
      const raisedRefundDetails = await fetchAllPromisedData(`${endpoint.refund.view}/${refundNumber}`);
      const { orderType, applicationId } = raisedRefundDetails;
      updateValues("raisedRefundDetails", raisedRefundDetails);

      const refundType = refundTypes?.find(type => type?.value === orderType);

      const searchSuccessCb = (searchResult) => {
        // debugger
        //2. selecting refund type
        updateValues("refundType", refundType);
        setStepsConfig(getStepsByRefundType(refundType?.value));

        //3. selecting the student
        updateValues("selectedStudent", searchResult?.list?.[0]);

        //4. clicking on Proceed next button
        next(1);
      }


      //1. searching the student
      // debugger
      searchHandler({ applicationId }, 0, true, 50, searchStudents, searchSuccessCb);
    } catch (err) {
      console.error(err);
    } finally {
      setFetchingRefundDetails(false);
    }
  }

  useEffect(() => {
    // debugger
    mode === 'edit' && Object.keys(dropdowns?.data)?.length > 0 && init();
  }, [dropdowns])

  return { fetchingRefundDetails }

}

export const isLatestTransferAppIdDiscontinued = async (psid, refundApplicationId, dropdowns) => {


  let allApplicationIds = [];

  //fetching all application Ids
  const resp = await searchStudents({ psid }, 0, dropdowns?.data);
  if (resp?.code === 200) {
    allApplicationIds = resp?.data?.studentApplicationDetailsSearchResponseDTOList || [];
  }

  //creating a map of applicationId : applicationDetails
  const applicationDetailsMap = allApplicationIds?.reduce((acc, curr) => {
    acc[curr?.applicationId] = curr;
    return acc;
  }, {})

  const traversedAppIdsSet = new Set([refundApplicationId]);

  let latestTransferAppId = refundApplicationId;

  while (true) {
    const nextTransferAppId = applicationDetailsMap?.[latestTransferAppId]?.transferApplicationId;
    if (traversedAppIdsSet.has(nextTransferAppId)) break;
    latestTransferAppId = nextTransferAppId;
    traversedAppIdsSet.add(nextTransferAppId);
  }

  const latestTransferAppIdDetails = applicationDetailsMap[latestTransferAppId];

  return latestTransferAppIdDetails?.programAction === 'DISC';

}

//filter Digital BUs
export const filterOutExcludedBUs = (list = []) =>list
  // (list||[]).filter(({ label }) => !["DW005"].includes(label));
